(function() {
  'use strict';

  angular.module('ringbaPortal').directive('pageTitle', pageTitle);
  // Author - Abhi
  // We can also use $rootScope to set the title, instead of manipulating the window title directly
  // But I'd rather not touch the $rootScope
  function pageTitle(
    $window,
    $transitions
  ) {
    const directive = {
      restrict: 'EA',
      link: link
    };
    return directive;

    function link(scope, element) {
      const defaultPageTitle = 'Ringba';
      // If we've been inserted as an element then we detach from the DOM because the caller
      // doesn't want us to have any visual impact in the document.
      // Otherwise, we're piggy-backing on an existing element so we'll just leave it alone.
      const tagName = element[0].tagName.toLowerCase();
      if (tagName === 'page-title' || tagName === 'pagetitle') {
        element.remove();
      }

      scope.$watch(
        function() {
          return element.text();
        },
        function(newTitle) {
          $window.document.title = newTitle || defaultPageTitle;
        }
      );
      const killSuccessHandler = $transitions.onSuccess({},
        function() {
          $window.document.title = defaultPageTitle;
          killSuccessHandler();
        }
      );
    }
  }

})();
